import { useField, useFormikContext } from 'formik';
import React from 'react';

const InputSpinner = ({ label, max, total, wrapperClassName, right, min = 1, ...props }) => {
    const [field] = useField(props);
    const { setFieldValue } = useFormikContext();

    const upClass = field.value < max && total < max ? 'cursor-pointer text-gray-800' : 'text-transparent';
    const downClass = field.value > 0 ? 'cursor-pointer text-gray-800 fa-flip-vertical' : 'text-transparent';

    const up = () => {
        if (field.value === max || total === max) {
            return;
        }

        if (field.value < min) {
            setFieldValue(field.name, min);
            return;
        }

        setFieldValue(field.name, field.value + 1);
    };

    const down = () => {
        if (field.value === 0) {
            return;
        }

        if (field.value === min) {
            setFieldValue(field.name, 0);
            return;
        }

        setFieldValue(field.name, field.value - 1);
    };

    const justifyClass = right ? 'justify-end' : 'justify-start';

    return (
        <div className={`flex items-center ${justifyClass}`}>
            <span className={`fas fa-lg fa-minus mr-2 ${downClass}`} onClick={down} />
            <div className="leading-3 text-lg font-semibold w-6 text-center">{field.value}</div>
            <span className={`fas fa-lg fa-plus ml-2 ${upClass}`} onClick={up} />
        </div>
    );
};

export default InputSpinner;
